import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import { ImageProps } from "@lib/image";

export interface StrapiContentSectionDTO extends StrapiDynamicZoneComponentDTO {
  style: "Default" | "Highlight" | "ImageLeft" | "ImageRight" | "Centered";
  heading: string;
  subheading: string;
  content: string;
  image: StrapiMediaDTO;
  links: StrapiLinkDTO[];
}

export class ContentSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  style: "Default" | "Highlight" | "ImageLeft" | "ImageRight" | "Centered";
  heading: string;
  subheading: string;
  content: MDXRemoteSerializeResult;
  image: ImageProps;
  links: LinkDTO[];
}
